/**
 * @flow
 */

import React, { useState, useCallback } from 'react';
import { Modal, Avatar } from '../../../../components';

import Navigation from './Navigation';
import PersonalInformation from '../../containers/details/PersonalInformation';
import Appointments from './Appointments';
import MasterList from './MasterList';

import type { ModalDialog, Client } from '../../../../type';
import type { NavigationItems } from './Navigation';

type ClientDetailsProps = {
    client: Client,
    selectedItem: NavigationItems,
    onItemClick: Function,
    onClientUpdate: Function,
    onModalClose: Function,
    isModalOpen: boolean,
    forcedSelectedItem?: NavigationItems,
} & ModalDialog;

const ClientDetails = ({
    client,
    trigger,
    onModalClose,
    isModalOpen,
    forcedSelectedItem,
    onClientUpdate,
    open,
}: ClientDetailsProps) => {
    const [selectedItem, selectItem] = useState('');
    const onItemClick = useCallback((e, { name }) => selectItem(name), []);

    const activeItem =
        selectedItem || forcedSelectedItem || 'personalInformation';

    return (
        <Modal
            onClose={onModalClose}
            open={Boolean(isModalOpen || open)}
            trigger={trigger}
        >
            <Modal.Header>
                <Avatar
                    name={`${client.firstName} ${client.lastName || ''}`}
                    size={48}
                    spaced="right"
                    round
                />
                {client.firstName} {client.lastName || ''}
            </Modal.Header>
            <Navigation selectedItem={activeItem} onItemClick={onItemClick} />
            {activeItem === 'personalInformation' && (
                <PersonalInformation
                    onClose={onModalClose}
                    client={client}
                    open={isModalOpen || open}
                    onClientUpdate={onClientUpdate}
                />
            )}
            {activeItem === 'appointments' && <Appointments client={client} />}
            {activeItem === 'masters' && (
                <MasterList client={client} onClose={onModalClose} />
            )}
        </Modal>
    );
};

export default ClientDetails;
